<template>
    <div>
        <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
             class="router-header mb-6">
            <!-- BREADCRUMB -->
            <vx-breadcrumb class="mb-1 md:block hidden" v-if="$route.meta.breadcrumb"
                           :route="$route" :isRTL="$vs.rtl"/>

            <div
                class="content-area__heading"
                :class="{'' : $route.meta.breadcrumb}">
                <h2 class="mb-1" v-if="pageTitleVisible">{{ routeTitle }}</h2>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageHeader',
    data () {
        return {
            routeTitle: this.$route.meta.pageTitle,
        };
    },
    watch: {
        '$route' () {
            this.routeTitle = this.$route.meta.pageTitle;
        },
    },
    computed: {
        pageTitleVisible () {
            return (typeof this.$route.meta.hidePageTitle === 'undefined') || (this.$route.meta.hidePageTitle === false);
        },
    },
};
</script>
